<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-select-advocado-voucher-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalSelectAdvocadoVoucher"
    ></button>
    <div
      class="modal fade"
      id="modalSelectAdvocadoVoucher"
      tabindex="-1"
      aria-labelledby="modalSelectAdvocadoVoucherLabel"
      aria-hidden="true"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Send Voucher Advocado</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-advocado-voucher-modal justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-3 d-flex align-items-center">Campaign</div>
              <div class="col-9">
                <Multiselect
                  :options="campaignOptions"
                  @change="changeCampaign"
                  :value="campaignDefault"
                  :canClear="false"
                />
                <span class="is-invalid" v-if="isCampaignRequire"
                  >Please select a campaign!</span
                >
              </div>
            </div>
            <div class="row">
              <div class="col-3 d-flex align-items-center">Voucher</div>
              <div class="col-9">
                <Multiselect
                  :options="optionOptions"
                  @change="changeOption"
                  :value="optionDefault"
                  :canClear="false"
                />
                <span class="is-invalid" v-if="isOptionRequire"
                  >Please select a voucher!</span
                >
              </div>
            </div>
            <!-- Members without an Advocado account are skipped by the API, so
                 say it up front rather than surprising the merchant afterwards. -->
            <p class="text-xs text-secondary mt-3 mb-0">
              Only members with an Advocado account will receive this voucher.
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              @click="confirmIssue"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "ModalSelectAdvocadoVoucher",
  components: {
    Multiselect,
  },
  props: {
    campaigns: {
      type: Array,
      default: () => [],
    },
    campaignDefault: {
      type: String,
      default: "",
    },
    optionDefault: {
      type: String,
      default: "",
    },
    isCampaignRequire: {
      type: Boolean,
      default: false,
    },
    isOptionRequire: {
      type: Boolean,
      default: false,
    },
    changeCampaign: {
      type: Function,
      default: () => {},
    },
    changeOption: {
      type: Function,
      default: () => {},
    },
    confirmIssue: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    selectedCampaign() {
      return this.campaigns.find(
        (campaign) => campaign.campaign_id === this.campaignDefault,
      );
    },
    campaignOptions() {
      return this.campaigns.map((campaign) => ({
        value: campaign.campaign_id,
        label: campaign.item_name || campaign.name || campaign.campaign_id,
      }));
    },
    // Advocado nests the issuable amounts under each campaign, so the second
    // dropdown is derived from the first rather than fetched again.
    optionOptions() {
      const selected = this.selectedCampaign;
      if (!selected) {
        return [];
      }
      return (selected.options || []).map((option) => ({
        value: option.option_id,
        label: this.optionLabel(selected, option),
      }));
    },
  },
  methods: {
    optionLabel(campaign, option) {
      const parts = [];
      if (option.earned_voucher) {
        parts.push(`${option.earned_voucher} x`);
      }
      parts.push(campaign.item_name || campaign.name || "Voucher");
      if (option.days_to_expire) {
        parts.push(`(expires in ${option.days_to_expire} days)`);
      }
      return parts.join(" ");
    },
  },
};
</script>
